
export const initialAppState = {
    loaded: true,
    cities: [],
    countries: [],
    websites: [],
    agents: [], 
    statuses: [],
    salers: [],
    dealers: [],
    marines: [],
    models: [],
    makers: [],
    roles: [],
    permissions: [],
    all_permissions: [],
    prices: [],
    calculator_prices: [],
    container_prices: [],
    companies: [],
    shippers: [],
    initialTypeOptions: [],
    container_statuses: [],
    assign_container_statuses: [], 
    user: null,
    fullwidth: false,
    isTable: true,
    error: null,
    isLoaded: false,
    ok: null,
};


export const appReducer = (state, action) => {
    switch (action.type) {
        case "SET_CITIES":
            return {
                ...state,
                cities: action.data || []
            };
        case "SET_COUNTRIES":
            return {
                ...state,
                countries: action.data || []
            };
        case "SET_WEBSITES":
            return {
                ...state,
                websites: action.data || []
            };
        case "SET_AGENTS":
                return {
                    ...state,
                    agents: action.data || []
        };
        case "SET_STATUSES":
            return {
                ...state,
                statuses: action.data || []
            };
        case "SET_SALERS": 
            return {
                ...state,
                salers: action.data || []
            };
        case "SET_DEALERS":
            return {
                ...state,
                dealers: action.data || []
            };
        case "SET_MARINE_LINES":
            return {
                ...state,
                marines: action.data || []
            };
        case "SET_MAKERS":
            return {
                ...state,
                makers: action.data || []
            };
        case "SET_ROLES":
            return {
                ...state,
                roles: action.data || []
            };
        case "SET_PERMISSIONS":
            return {
                ...state,
                permissions: action.data || []
            };
        case "SET_ALL_PERMISSIONS":
            return {
                ...state,
                all_permissions: action.data || []
            };
        case "SET_MODELS":
            return {
                ...state,
                models: action.data || []
            };
        case "SET_PRICES":
            return {
                ...state,
                prices: action.data || []
            };
        case "SET_CONTAINER_PRICE":
                return {
                    ...state,
                    container_prices: action.data || []
        };
        case "SET_CALCULATOR_PRICES":
            return {
                ...state,
                calculator_prices: action.data || []
            };
        case "SET_COMPANIES":
            return {
                ...state,
                companies: action.data || []
            };
        case "SET_SHIPPERS":
            return {
                ...state,
                shippers: action.data || []
            };
        case "SET_CONTAINER_STATUSES":
            return {
                ...state,
                container_statuses: action.data || []
            };
        case "SET_INITIALTYPEOPTIONS":
            return {
                ...state,
                initialTypeOptions: action.data || []
            };
        case "SET_ASSIGN_CONTAINER_STATUSES":
                return {
                    ...state,
                    assign_container_statuses: action.data || []
                };
        case "SET_ERROR":
            return {
                ...state,
                error: action.data
            };
        case "SET_OK":
            return {
                ...state,
                ok: action.data
            };
        case "SET_IS_TABLE":
            const isTable = action.data
            localStorage.setItem('isTable', JSON.stringify(isTable));

            return {
                ...state,
                isTable: isTable,
                fullwidth: isTable,
            };
        case "SET_IS_TABLE_REVERT":
                var newIsTable = !state.isTable
                localStorage.setItem('isTable', JSON.stringify(newIsTable));
    
                return {
                    ...state,
                    isTable: newIsTable,
                    fullwidth: newIsTable,
                };
        case "SET_FULLWIDTH":
            return {
                ...state,
                fullwidth: action.data
            };
        case "SET_USER": 
            return {
                    ...state,
                    user: action.data
            };
        case "SET_IS_LOADED":
                return {
                    ...state,
                    isLoaded: true
                };
        default:
            return state;
    }
};
